export const sektorlerData = [
    {
        name: {
            tr: 'Otomobil',
            en: 'Automobile',
            de: 'Automobil'
        },
        link: 'otomobil',
        image: '',
        description: {
            tr: 'Otomotiv sektörüne yönelik lojistik çözümlerimiz, tecrübeli ekibimizin güvenilirliği ve yüksek donanımlı altyapımızla birleşerek her zaman zamanında teslimat sağlar.',
            en: 'Our logistics solutions for the automotive industry ensure on-time delivery at all times by combining the reliability of our experienced team with our high-tech infrastructure.',
            de: 'Unsere Logistiklösungen für die Automobilindustrie gewährleisten jederzeit pünktliche Lieferungen, indem sie die Zuverlässigkeit unseres erfahrenen Teams mit unserer hochmodernen Infrastruktur kombinieren.'
        },
        text: {
            tr: [
                'zz',
                'zz'
            ],
            en: [
                'zz',
                'zz'
            ],
            de: [
                'zz',
                'zz'
            ],
        }
    },
    {
        name: {
            tr: 'Tekstil',
            en: 'Textile',
            de: 'Textil'
        },
        link: 'tekstil',
        image: '',
        description: {
            tr: 'Tekstil sektörünün hassas taşımacılık gereksinimlerini modern altyapımız ve güvenilir hizmet anlayışımızla karşılıyoruz.',
            en: 'We meet the textile industry’s sensitive transportation needs with our modern infrastructure and reliable service approach.',
            de: 'Wir erfüllen die sensiblen Transportanforderungen der Textilindustrie mit unserer modernen Infrastruktur und unserem zuverlässigen Serviceansatz.'
        },
        text: {
            tr: [
                'zz',
                'zz'
            ],
            en: [
                'zz',
                'zz'
            ],
            de: [
                'zz',
                'zz'
            ],
        }
    },
    {
        name: {
            tr: 'Elektronik',
            en: 'Electronics',
            de: 'Elektronik'
        },
        link: 'elektronik',
        image: '',
        description: {
            tr: 'Elektronik ürünlerin taşınmasında zamanında teslimat, yüksek donanım ve profesyonel yaklaşımla güvenliği ön planda tutuyoruz.',
            en: 'In the transportation of electronic products, we prioritize security with on-time delivery, high technology, and a professional approach.',
            de: 'Beim Transport von Elektronikprodukten legen wir mit pünktlicher Lieferung, hoher Technologie und einem professionellen Ansatz großen Wert auf Sicherheit.'
        },
        text: {
            tr: [
                'zz',
                'zz'
            ],
            en: [
                'zz',
                'zz'
            ],
            de: [
                'zz',
                'zz'
            ],
        }
    },
    {
        name: {
            tr: 'Gıda',
            en: 'Food',
            de: 'Lebensmittel'
        },
        link: 'gida',
        image: '',
        description: {
            tr: 'Gıda taşımacılığında tazeliği koruyan çözümler, tecrübeli ekip ve güvenilir süreçlerle ürünlerinizi zamanında ve güvenle taşıyoruz.',
            en: 'In food transportation, we deliver your products on time and safely with freshness-preserving solutions, an experienced team, and reliable processes.',
            de: 'Beim Lebensmitteltransport liefern wir Ihre Produkte pünktlich und sicher mit frischeerhaltenden Lösungen, einem erfahrenen Team und zuverlässigen Prozessen.'
        },
        text: {
            tr: [
                'zz',
                'zz'
            ],
            en: [
                'zz',
                'zz'
            ],
            de: [
                'zz',
                'zz'
            ],
        }
    },
    {
        name: {
            tr: 'Diğer Sektörler',
            en: 'Other Sectors',
            de: 'Andere Branchen'
        },
        link: 'diger-sektorler',
        image: '',
        description: {
            tr: 'Farklı sektörlerin lojistik ihtiyaçlarına, yüksek donanımlı altyapımız, güvenilir hizmet anlayışımız ve zamanında teslimat çözümlerimizle destek oluyoruz.',
            en: 'We support the logistics needs of different industries with our high-tech infrastructure, reliable service approach, and on-time delivery solutions.',
            de: 'Wir unterstützen die Logistikanforderungen verschiedener Branchen mit unserer hochmodernen Infrastruktur, unserem zuverlässigen Serviceansatz und unseren pünktlichen Lieferlösungen.'
        },
        text: {
            tr: [
                'zz',
                'zz'
            ],
            en: [
                'zz',
                'zz'
            ],
            de: [
                'zz',
                'zz'
            ],
        }
    }
];
